import { Box, Button, LinearProgress, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import AddIcon from "@mui/icons-material/Add";
import GroupageItemCard from "./GroupageItemCard";
import GroupageFormDialog from "./GroupageFormDialog";
import GroupageSearchDialog from "./GroupageSearchDialog";

const GroupageList = () => {
  const { groupages, isLoading, isError, message } = useSelector(
    (state) => state.groupages
  );

  const [createGroupageOpen, setCreateGroupageOpen] = useState(false);
  const [searchGrouppageOpen, setSearchGroupageOpen] = useState(false);
  const [selectedGroupage, setSelectedGroupage] = useState(null);

  const handleCreateGroupageOpen = () => {
    setCreateGroupageOpen(true);
  };

  const handleCreateGroupageClose = () => {
    setCreateGroupageOpen(false);
  };

  const handleSearchGroupageOpen = (groupage) => {
    setSelectedGroupage(groupage);
    setSearchGroupageOpen(true);
  };

  const handleSearchGroupageClose = () => {
    setSelectedGroupage(null);
    setSearchGroupageOpen(false);
  };

  return (
    <Box>
      <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 2 }}>
        <Typography variant="h6">Consolidations</Typography>
        <Button
          size="small"
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={handleCreateGroupageOpen}
        >
          CREATE
        </Button>
        <GroupageFormDialog
          open={createGroupageOpen}
          handleClose={handleCreateGroupageClose}
        />
        <GroupageSearchDialog
          groupage={selectedGroupage}
          open={searchGrouppageOpen}
          handleClose={handleSearchGroupageClose}
        />
      </Stack>
      {isLoading && <LinearProgress />}
      {groupages &&
        groupages.map((groupage) => (
          <GroupageItemCard key={groupage.id} groupage={groupage} onSearchOpen={handleSearchGroupageOpen}/>
        ))}
      {isError && message}
    </Box>
  );
};

export default GroupageList;
